// import React from "react";
// import { useEpochFormatter } from "./useEpochFormatter";

// const EpochDate = ({
//   date = null,
//   prefix = "",
//   postfix = "",
//   appendFormat = "",
// }) => {
//   const formatEpoch = useEpochFormatter();
//   const formatted = formatEpoch(date, appendFormat);

//   return <span>{`${prefix}${formatted}${postfix}`}</span>;
// };

// export default EpochDate;

import React from "react";
import { useEpochFormatter } from "./useEpochFormatter";

const EpochDate = ({
  date = null,
  prefix = "",
  postfix = "",
  appendFormat = "",
  relative = false,
}) => {
  const formatEpoch = useEpochFormatter();
  const formatted = formatEpoch(date, appendFormat, false, relative);

  return <span>{`${prefix}${formatted}${postfix}`}</span>;
};

export default EpochDate;
